import { render, staticRenderFns } from "./BotMessage.vue?vue&type=template&id=4d274e9c&"
import script from "./BotMessage.vue?vue&type=script&lang=js&"
export * from "./BotMessage.vue?vue&type=script&lang=js&"
import style0 from "./BotMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports